import styles from "./ChatMemberListItem.styles.scss";
import ListItem from "../list-item";
import {format, parseISO, isToday} from "date-fns";
import Icon from "../Icon/Icon";
import {useState} from "preact/hooks";
import {toLastSeen} from "../../helpers";

/**
 *
 * @param {String} name
 * @param {String} status is a user.status string (e.g: 'offline:2020-04-02T14:00:00'
 * @param {Function} onClick
 * @param {Boolean} loading
 * @returns {*}
 * @constructor
 */
const ChatMemberListItem = ({name = '', status = '', internalId = '', onRequestToggleMute, loading = false, mutedUntil = ''}) => {
  const [isHovering, setHovering] = useState(false);

  const onMouseEnter = () => {
    setHovering(true);
  };

  const onMouseLeave = () => {
    setHovering(false);
  };

  const title = name;
  let subtitle = '';
  if (status.startsWith('online'))
    subtitle = 'online';
  else if (status.startsWith('offline')) {
    const time = status.replace("offline:", "");
    subtitle = toLastSeen(time);
  }

  return <ListItem loading={loading} title={title}
                   subtitle={subtitle}
                   hoverFeedback={true}
                   right={renderIcon(internalId, mutedUntil, isHovering, onRequestToggleMute)}
                   onMouseEnter={onMouseEnter}
                   onMouseLeave={onMouseLeave}
                   className={styles.container}
                   fadedSubtitle
  />;
};

const renderIcon = (internalId, mutedUntil, isHovering, onRequestToggleMute) => {
  const isSilenced = mutedUntil && mutedUntil > new Date().toISOString();
  if (isSilenced)
    return <Icon onClick={() => onRequestToggleMute(internalId)} title={getMutedIconTitle(mutedUntil)} name="volume_off" />;
  else if (isHovering)
    return <Icon onClick={() => onRequestToggleMute(internalId)} title="Silenciar usuário" name="volume_high" />;
  else
    return <div style={{width: 24, height: 24}} />;
};

const getMutedIconTitle = (mutedUntil) => {
  const date = parseISO(mutedUntil);
  let message = '';
  if (mutedUntil) {
    message = 'Silenciado até as ' + format(date, 'HH:mm');
    if (!isToday(date))
      message += ' do dia ' + format(date, 'dd/MM');
  }
  return message;
};

export default ChatMemberListItem;



// WEBPACK FOOTER //
// ./components/ChatMemberListItem/ChatMemberListItem.js